import { makeStyles } from '@material-ui/core';

export const cmpStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.colors.Background_Secondary,
    borderRadius: theme.spacing(1),
  },
}));
